import React, { Fragment, useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './shared-preview.styles'
import Head from './head/head.container'
import PresentationPreview from '../../presentation-preview/presentation-preview'

const SharedPreview = ({
  classes,
  pending,
  presentation,
  onClose,
  onCopy,
  onMount
}) => {
  useEffect(() => {
    onMount()
  }, []) // eslint-disable-line

  return (
    <Fragment>
      <Head />
      <div className={classes.previewHolder}>
        <PresentationPreview
          onClose={onClose}
          onCopy={onCopy}
          presentation={pending ? null : presentation}
          pending={pending}
        />
      </div>
    </Fragment>
  )
}

export default injectSheet(styles)(SharedPreview)
